import { OrderByDirection } from "@topyourthree/datastore/core";
function getCurrentLang() {
    if (typeof window === "undefined") {
        return "ja";
    }
    const pathname = window.location.pathname;
    if (pathname.includes("/en/")) {
        return "en";
    }
    return "ja";
}
export function SeoNavbarBackend() {
    return {
        defaultOrder: {
            field: "id",
            direction: OrderByDirection.ASC,
        },
        fetch: () => {
            const lang = getCurrentLang();
            return {
                endpoint: `seo-navbar/getSeoNavbar.php?lang=${encodeURIComponent(lang)}`,
                isGaf: true,
            };
        },
        push: undefined,
        set: undefined,
        update: undefined,
        remove: undefined,
    };
}
